import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_GDA_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'diseaseName',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'geneSymbol',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneDescription',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'geneEnsemblIDs',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
    'chemPrefName',
    'chemID',
    'diseaseCode_DO',
    'diseaseCode_MSH',
    'diseaseCode_HPO',
    'diseaseCode_ICD10',
    'diseaseCode_ICD9CM',
    'diseaseCode_NCI',
    'diseaseCode_OMIM',
    'diseaseCode_ORDO',
    'diseaseCode_MONDO',
    'diseaseCode_EFO',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'diseaseName',
    'geneSymbol',
    'geneDescription',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numCTs',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'geneDSI',
    'geneDPI',
    'genepLI',
  ],
};